import React, { useEffect } from 'react';
import ScalarSpreadsheet from 'components/ScalarSpreadsheet';
import { TransactionCompsCell } from 'pages/ValuationsAllocation/approaches/TransactionComps/types';
import { ExchangeRatesReferenceTableProps } from './ExchangeRatesReferenceTable.props';

const ExchangeRatesReferenceTable = (props: ExchangeRatesReferenceTableProps) => {
  const { exchangeRateSheet, format, formatDispatch, onChange } = props;

  useEffect(() => {
    if (format.currency.additionalCurrencies) {
      onChange(exchangeRateSheet.cells.financialsCurrency as TransactionCompsCell, format.currency.exchangeRate!);
      onChange(exchangeRateSheet.cells.A1 as TransactionCompsCell, `Exchange Rate to ${format.currency.code}`);
      format.currency.additionalCurrencies.forEach(additionalCurrency => {
        onChange(
          exchangeRateSheet.cells[additionalCurrency.currencyType] as TransactionCompsCell,
          additionalCurrency.exchangeRate!
        );
      });
    }
  }, [format, exchangeRateSheet, onChange]);

  return (
    // @ts-expect-error: ScalarSpreadsheet is not typed
    <ScalarSpreadsheet
      {...exchangeRateSheet}
      key={exchangeRateSheet.name}
      onChange={onChange}
      sheet={exchangeRateSheet}
      format={format}
      formatDispatch={formatDispatch}
      displayColumnIndicator
      displayRowIndicator
    />
  );
};

export default ExchangeRatesReferenceTable;
